<div class="event-dropdown-container">
  <h4 i18n>Veranstaltungen auswählen</h4>
  <mat-form-field>
    <mat-label i18n>Veranstaltungen</mat-label>
    <mat-select [(ngModel)]="selectedIds" multiple>
      @for (event of events; track event) {
        <mat-option [value]="event.id">{{ event.name }}</mat-option>
      }
    </mat-select>
    <mat-hint i18n>{selectedSubmissionCount, plural, =1 {1 Abgabe} other {{{ selectedSubmissionCount }} Abgaben}} enthalten</mat-hint>
  </mat-form-field>
</div>

<div class="event-dropdown-container">
  <h4 i18n>Art des Exports auswählen</h4>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label i18n>Art des Exports</mat-label>
    <mat-select [(ngModel)]="exportType">
      <mat-option value="standard" i18n>Standardauswertung</mat-option>
      <mat-option value="alternatives-and-objectives" i18n>Alternativen/Ziele</mat-option>
      <mat-option value="project-files" i18n>Projektdateien</mat-option>
    </mat-select>
  </mat-form-field>
</div>

@switch (exportType) {
  @case ('standard') {
    <dt-standard-event-export [selectedEvents]="selectedIds"></dt-standard-event-export>
  }
  @case ('alternatives-and-objectives') {
    <dt-alt-and-obj-event-export [selectedEvents]="selectedIds"></dt-alt-and-obj-event-export>
  }
  @case ('project-files') {
    <dt-project-file-event-export [selectedEvents]="selectedIds"></dt-project-file-event-export>
  }
}

<ng-template #loadingOrError>
  <div class="loading-container">
    @if (hasError) {
      <mat-error class="dt-error" i18n>Beim Laden der Veranstaltungen ist ein Fehler aufgetreten.</mat-error>
    } @else {
      <mat-spinner></mat-spinner>
    }
  </div>
</ng-template>
